document.addEventListener("DOMContentLoaded", () => {
  const callback = (jdgmWidg) => {
    const nodeToChange = document.querySelector(
      ".jdgm-rev-widg__summary-stars"
    );
    const avg = document.createElement("span");
    avg.classList.add("avg");
    avg.textContent = jdgmWidg.dataset.averageRating;
    nodeToChange.appendChild(avg);

    const stars = document.querySelectorAll(".jdgm-histogram__star");
    stars.forEach((el) => {
      el.textContent = el.querySelectorAll(".jdgm--on").length;
    });
  };

  const interval = setInterval(() => {
    const jdgmWidg = document.querySelector(".jdgm-rev-widg");
    if (jdgmWidg) {
      clearInterval(interval);
      callback(jdgmWidg);
    }
  }, 500);
});
